<template>
  <div>
  <div class="sideBar">
    <ul>
      <li class="gzs">
        <div class="limg" @click="handleGzs">
          <img src="@/assets/images/gzs.svg" alt="" width="35">
        </div>
      </li>
      <li class="tel">
        <div class="limg">
          <img src="@/assets/images/side-phone.png" alt="" width="35" height="35"></div>
        <div class="hideLayer telLayer">
          <div class="num">{{ info.phone }}</div>
        </div>
      </li>
      <li class="emai">
        <div class="limg">
          <img src="@/assets/images/side-email.png" alt="" width="35" height="35">
          <div class="hideLayer emailLayer">
            <div class="num">{{ info.email }}</div>
          </div>
        </div>
      </li>
      <li class="qq">
        <div class="limg">
          <img src="@/assets/images/qq.svg" alt="" width="32" height="32">
          <div class="hideLayer qqLayer">
            <div class="num">{{ info.qq }}</div>
          </div>
        </div>
      </li>
      <li class="eweima">
        <div class="limg"><img src="@/assets/images/side-ewma.png" alt="" width="35" height="35"></div>
        <div class="hideLayer ewmLayer">
          <div class="ewm"><img :src="info.qrcode" width="126" height="126">
          </div>
        </div>
      </li>

      <li class="cd-top" @click="goTop">
        <div class="limg"><a href="javascript:;"><img src="@/assets/images/side-top.png" alt="" width="35" height="35"></a>
        </div>
      </li>
    </ul>
  </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "Right",
  data() {
    return {
      info: {
        phone: '',
        email: '',
        qq: '',
        qrcode: '',
      },
      contactInfo: {
        phone: '',
        email: ''
      }
    };
  },
  mounted() {
    this.queryCompanyInfo();
  },

  methods:{
    goTop() {
      (function smoothscroll() {
        var currentScroll =
            document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },

    async queryCompanyInfo() {
      const {data} = await request.get("/outSiteMenu/queryCompanyInfo")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.info = data.data;
      }
    },

    handleGzs(){
      this.$router.push({path: '/page1', query: {id: 4472}});
    }
  },
};
</script>
<style scoped>

/*侧边栏*/
.sideBar {
  position: fixed;
  bottom: 100px;
  right: 15px;
  z-index: 1001;
}


.sideBar img{
  border: 0;
  vertical-align: middle;
}


.sideBar ul li {
  margin-bottom: 1px;
  cursor: pointer;
  position: relative;
  list-style: none;
}

.sideBar ul .gzs{
  display: none;
}

.sideBar ul .gzs .limg{
  height: 170px;
  padding: 10px 0;
  background-color: brown;
}

.sideBar ul .tel:hover .telLayer{
  display: block;
}


.sideBar ul .emai:hover .emailLayer {
  display: block;
}

.sideBar ul .qq:hover .qqLayer {
  display: block;
}

.sideBar ul .eweima:hover .ewmLayer {
  display: block;
}

.sideBar ul li .limg {
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.3);
  text-align: center;
  line-height: 60px;
}
.sideBar ul li:hover .limg {
  background: #f57c00;
}

.sideBar ul li:hover .limg {
  background: #f57c00;

}

.sideBar ul li .wen {
  line-height: 24px;
  font-size: 14px;
  color: #fff;
  padding-top: 8px;
}
.sideBar ul li .ewmLayer {
  width: 146px;
  height: 146px;
  background: #f57c00;
  display: none;
  position: absolute;
  left: -146px;
  bottom: 0;
}
.sideBar ul li .ewmLayer .ewm {
  padding: 10px;
}
.sideBar ul li .ewmLayer .ewm img {
  width: 126px;
}
.sideBar ul li .telLayer {
  width: 195px;
  height: 60px;
  background: #f57c00;
  display: none;
  position: absolute;
  left: -195px;
  top: 0;
}

.sideBar ul li .emailLayer {
  width: 240px;
  height: 60px;
  background: #f57c00;
  display: none;
  position: absolute;
  left: -240px;
  top: 0;
}

.sideBar ul li .qqLayer {
  width: 240px;
  height: 60px;
  background: #f57c00;
  display: none;
  position: absolute;
  left: -240px;
  top: 0;
}

.sideBar ul li .num {
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 22px;
  font-family: mont;
}
.sideBar ul li .kefuLayer {
  width: 235px;
  height: 60px;
  background: #f57c00;
  display: none;
  position: absolute;
  left: -235px;
  top: 0;
}
.sideBar ul li .kefuLayer dl {
  padding-left: 30px;
}
.sideBar ul li .kefuLayer dd {
  margin-right: 24px;
  float: left;
}
.sideBar ul li .kefuLayer dd a {
  display: block;
  font-size: 14px;
  padding-left: 32px;
  height: 60px;
  line-height: 60px;
  color: #fff;
  position: relative;
}
.sideBar ul li .kefuLayer dd a img {
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -12px;
  width: 24px;
}
</style>

